import { render, staticRenderFns } from "./list_item.html?vue&type=template&id=0852c710&"
import script from "./ListItemSchool.vue?vue&type=script&lang=js&"
export * from "./ListItemSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports